/* tslint:disable */
/* eslint-disable */
export enum CharterContractReportChargeTypes {
  Catering = 'CATERING',
  Internet = 'INTERNET',
  LayoverWaiting = 'LAYOVER_WAITING',
  All = 'ALL',
  Flight = 'FLIGHT',
}
